import React, { useState } from "react";
import styled from "styled-components";

export default function Input({
  name,
  type,
  onChange,
  placeholder,
  defaultValue,
  label,
  disabled,
  padding = "20px 15px",
  width = "100%",
  bottom = "20px",
  labelColor = "#000",
  background,
  value,
}) {
  const [readOnly, setReadOnly] = useState(true);

  return (
    <div style={{ width: "100%" }}>
      <Label
        style={{
          color: labelColor,
        }}
        htmlFor={name}
      >
        {label}
      </Label>
      <AppInputStyle
        style={{
          border: `1px solid ${disabled ? "#D0D5DD" : "#89888896"}`,
          width: width,
          marginBottom: bottom,
          background: background,
        }}
      >
        <div>
          <input
            readOnly={readOnly}
            onFocus={() => setReadOnly(false)}
            onBlur={() => setReadOnly(true)}
            autocomplete="off"
            type={type}
            name={name}
            onChange={onChange}
            required
            defaultValue={defaultValue}
            value={value}
            placeholder={placeholder}
            disabled={disabled}
            style={{ padding: padding }}
          />
        </div>
      </AppInputStyle>
    </div>
  );
}

const Label = styled.label`
  font-size: 16px;
  font-weight: 500;
`;
const AppInputStyle = styled.div`
  outline: none;
  border-radius: 6px;
  background-color: white;
  padding: 0;
  margin-top: 10px;

  input {
    width: 100%;
    height: 100%;
    appearance: none;
    border-radius: 6px;
    outline: none;
    border: none;
    background: none;
    font-size: 16px;
  }
  input::placeholder {
    color: #ababab;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    display: none;
  }
`;
